"use strict";
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PricingFormula = void 0;
var PricingFormula;
(function (PricingFormula) {
    PricingFormula["MIN_PRICE_FORMULA"] = "MIN_PRICE_FORMULA";
    PricingFormula["MAX_REBATE_FORMULA"] = "MAX_REBATE_FORMULA";
})(PricingFormula = exports.PricingFormula || (exports.PricingFormula = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWVhdC1jb25maWd1cmF0aW9uLmVudW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbWVhdC1jb25maWd1cmF0aW9uL3R5cGVzL21lYXQtY29uZmlndXJhdGlvbi5lbnVtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7O0dBTUc7OztBQUVILElBQVksY0FHWDtBQUhELFdBQVksY0FBYztJQUN4Qix5REFBdUMsQ0FBQTtJQUN2QywyREFBeUMsQ0FBQTtBQUMzQyxDQUFDLEVBSFcsY0FBYyxHQUFkLHNCQUFjLEtBQWQsc0JBQWMsUUFHekIifQ==